import React from 'react';
import PropTypes from 'prop-types';
import Detail from '../detail/DetailWrapper';
import { connect } from 'react-redux';
import { showMsg } from '../utils/logger';

class DetailComponent extends React.Component {
  render() {
    return (
      <Detail
        currentEl={this.props.currentEl}
        toolbarActions={this.props.toolbarActions}
        onSubmit={this.props.onSubmit}
        onUpdate={this.props.onUpdate}
        onCreate={this.props.onCreate}
        onChange={this.props.onChangeField}
        onDiscard={this.props.onDiscard}
        onBlur={this.props.onBlur}
        schema={this.props.schema}
        data={this.props.detailData}
        isLoading={this.props.isDetailLoading}
        primaryField={this.props.primaryField}
        onGet={this.props.onGet}
        allData={this.props.allData}
        parentProps={this.props.parentProps}
        disabled={this.props.disabled}
        akcDisabled={this.props.akcDisabled}
        akcHidden={this.props.akcHidden}
        akc={this.props.akc}
        isPicker={this.props.isPicker}
        modified={this.props.modified}
        ui={this.props.ui}
        args={this.props.args}
        pages={this.props.pages}
        componentFactory={this.props.componentFactory}
        akcFactory={this.props.akcFactory}
        withMeta
        db={this.props.db}
        showAbort={this.props.showAbort}
        reducer={this.props.reducer}
        toolbarHidden={this.props.toolbarHidden}
        hiddenBack={this.props.hiddenBack}
        hiddenSave={this.props.hiddenSave}
        frms={this.props.frms}
        sidebarHorizontal={this.props.sidebarHorizontal}
      />
    );
  }
}

DetailComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  detailData: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  allData: PropTypes.array.isRequired,
  isDetailLoading: PropTypes.bool,
  onGet: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDiscard: PropTypes.func,
  onBlur: PropTypes.func,
  primaryField: PropTypes.string.isRequired,
  schema: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  akcDisabled: PropTypes.number,
  akcHidden: PropTypes.number,
  isPicker: PropTypes.bool,
  modified: PropTypes.bool,
  componentFactory: PropTypes.func,
  ui: PropTypes.array,
  args: PropTypes.object,
  pages: PropTypes.array,
  currentEl: PropTypes.element,
  toolbarActions: PropTypes.any,
  db: PropTypes.string,
  toolbarHidden: PropTypes.bool,
  hiddenBack: PropTypes.bool,
  hiddenSave: PropTypes.bool,
  frms: PropTypes.array,
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailComponent);